import React from 'react';
import { ECrmDirectoryEntryType } from 'services/CrmApi/types/DirectoryEntry';
import { ActivityFilters } from '../ActivityFilters/ActivityFilters';
import { IActivityFiltersAction, IActivityFiltersState } from 'containers/CRM/hooks/useActivityFilters';
import { ActivityButtons } from '../ActivityFilters/ActivityButtons';
import classnames from 'classnames';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';

interface IActivityFiltersAndButtonsProps {
  // directoryEntryId and directoryEntryType will be undefined for all activity page
  directoryEntryId?: string;
  directoryEntryType?: ECrmDirectoryEntryType;
  activityFilters: IActivityFiltersState;
  dispatchActivityFilters: React.Dispatch<IActivityFiltersAction>;
  activityFiltersDisabled: boolean;
  onCreateActivity: () => void;
  resetHighlightedActivity: () => void;
}

export const ActivityFiltersAndButtons: React.FC<IActivityFiltersAndButtonsProps> = ({
  directoryEntryId,
  directoryEntryType,
  activityFilters,
  dispatchActivityFilters,
  activityFiltersDisabled,
  onCreateActivity,
  resetHighlightedActivity,
}) => {
  const { isMobile, isTablet, isDesktop, isDesktopHD } = useResponsive();
  const className = classnames('flex mt-[30px]', {
    'justify-between flex-row-reverse items-start': isDesktop || isDesktopHD,
    'justify-end flex-col gap-[30px]': isMobile || isTablet,
  });

  return (
    <div className={className}>
      <div className="activity-buttons-container flex gap-[20px]">
        {directoryEntryId && directoryEntryType ? (
          <ActivityButtons
            directoryEntryId={directoryEntryId}
            directoryEntryType={directoryEntryType}
            onCreateActivity={onCreateActivity}
          />
        ) : null}
      </div>
      <div className="activity-filters-container flex flex-col gap-[15px] lg:flex-1">
        <div className="activity-filters flex">
          <ActivityFilters
            activityFilters={activityFilters}
            dispatchActivityFilters={dispatchActivityFilters}
            resetHighlightedActivity={resetHighlightedActivity}
            disabled={activityFiltersDisabled}
          />
        </div>
      </div>
    </div>
  );
};
